if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute('available')) return;

        this.errorHtml = this.querySelector('template')
          .content.firstElementChild
          .cloneNode(true);

        this.onClickRefreshList =
          this.onClickRefreshList.bind(this);

        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        let rootUrl = this.dataset.rootUrl;

        if (!rootUrl.endsWith('/')) {
          rootUrl += '/';
        }

        const variantSectionUrl =
          `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const parsedHTML =
              new DOMParser().parseFromString(
                text,
                'text/html'
              );

            this.renderPreview(parsedHTML);
          })
          .catch(() => {
            const button =
              this.querySelector('button');

            if (button) {
              button.removeEventListener(
                'click',
                this.onClickRefreshList
              );
            }

            this.renderError();
          });
      }

      onClickRefreshList() {
        this.fetchAvailability(
          this.dataset.variantId
        );
      }

      renderError() {
        this.replaceChildren(
          this.errorHtml.cloneNode(true)
        );

        const button =
          this.querySelector('button');

        if (button) {
          button.addEventListener(
            'click',
            this.onClickRefreshList
          );
        }
      }

      renderPreview(parsedHTML) {
        const drawer = document.querySelector(
          'pickup-availability-drawer'
        );

        if (drawer) drawer.remove();

        const previewElement =
          parsedHTML.querySelector(
            'pickup-availability-preview'
          );

        if (!previewElement) {
          this.replaceChildren();
          this.removeAttribute('available');
          return;
        }

        this.replaceChildren(
          previewElement.cloneNode(true)
        );

        this.setAttribute('available', '');

        const drawerElement =
          parsedHTML.querySelector(
            'pickup-availability-drawer'
          );

        if (drawerElement) {
          document.body.appendChild(
            drawerElement.cloneNode(true)
          );
        }

        const button =
          this.querySelector('button');

        if (button) {
          button.addEventListener(
            'click',
            (evt) => {
              document
                .querySelector(
                  'pickup-availability-drawer'
                )
                .show(evt.target);
            }
          );
        }
      }
    }
  );
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define(
    'pickup-availability-drawer',
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick =
          this.handleBodyClick.bind(this);

        // Close button
        this.querySelector('button')
          ?.addEventListener('click', () => {
            this.hide();
          });

        // Backdrop click
        const backdrop = this.querySelector(
          '.pickup-drawer__backdrop'
        );

        if (backdrop) {
          backdrop.addEventListener(
            'click',
            () => {
              this.hide();
            }
          );
        }

        // ESC key close
        this.addEventListener(
          'keyup',
          (event) => {
            if (
              event.code.toUpperCase() ===
              'ESCAPE'
            ) {
              this.hide();
            }
          }
        );
      }

      handleBodyClick(evt) {
        const target = evt.target;

        if (
          target !== this &&
          !target.closest(
            'pickup-availability-drawer'
          ) &&
          !target.closest(
            '.pickup-drawer__backdrop'
          ) &&
          target.id !==
            'ShowPickupAvailabilityDrawer'
        ) {
          this.hide();
        }
      }

      hide() {
        this.removeAttribute('open');

        document.body.removeEventListener(
          'click',
          this.onBodyClick
        );

        document.body.classList.remove(
          'overflow-hidden'
        );

        removeTrapFocus(this.focusElement);

        window.scrollTo(
          0,
          this.scrollPosition || 0
        );
      }

      show(focusElement) {
        this.focusElement = focusElement;

        this.scrollPosition =
          window.scrollY;

        this.setAttribute('open', '');

        document.body.addEventListener(
          'click',
          this.onBodyClick
        );

        document.body.classList.add(
          'overflow-hidden'
        );

        requestAnimationFrame(() => {
          window.scrollTo(
            0,
            this.scrollPosition
          );
        });

        trapFocus(this);
      }
    }
  );
}